const routes = [
  {
    path: '/settings/parameters/list',
    name: 'settings/parameters/list',
    component: () => import('@/views/SuperAdmin/Settings/ParameterList.vue'),
    meta: {
      requiresAuth: true,
      key: '12002',
      pageTitle: 'Settings',
      breadcrumb: [
        {
          text: 'Settings',
          active: false,
        },
        {
          text: 'Parameter',
          active: true,
        },
      ],
    },
  },
  {
    path: '/company-settings/parameter/list',
    name: 'company-settings/parameter/list',
    component: () => import('@/views/SuperAdmin/Settings/ParameterList.vue'),
    meta: {
      requiresAuth: true,
      key: '8000',
      pageTitle: 'Company Parameters',
      breadcrumb: [
        {
          text: 'Company Settings',
          active: false,
        },
        {
          text: 'Company Parameter',
          active: true,
        },
      ],
    },
  },
//   {
//     path: '/settings/polymer-grade',
//     name: 'settings/polymer-grade',
//     component: () => import('@/views/Company/Settings/Grade/GradeList.vue'),
//     meta: {
//       requiresAuth: true,
//       key: '9002',
//       pageTitle: 'Settings',
//       breadcrumb: [
//         {
//           text: 'Settings',
//           active: false,
//         },
//         {
//           text: 'Grade',
//           active: true,
//         },
//       ],
//     },
//   },
//   {
//     path: '/settings/polymer-process',
//     name: 'settings/polymer-process',
//     component: () => import('@/views/Company/Settings/Process/ProcessList.vue'),
//     meta: {
//       requiresAuth: true,
//       key: '9003',
//       pageTitle: 'Settings',
//       breadcrumb: [
//         {
//           text: 'Settings',
//           active: false,
//         },
//         {
//           text: 'Process',
//           active: true,
//         },
//       ],
//     },
//   },
//   {
//     path: '/settings/polymer-application',
//     name: 'settings/polymer-application',
//     component: () => import('@/views/Company/Settings/Application/ApplicationList.vue'),
//     meta: {
//       requiresAuth: true,
//       key: '9004',
//       pageTitle: 'Settings',
//       breadcrumb: [
//         {
//           text: 'Settings',
//           active: false,
//         },
//         {
//           text: 'Application',
//           active: true,
//         },
//       ],
//     },
//   },
]

export default routes
